$(document).ready(() => {
  $('#salesforce_id_bulk_upload_csv').fileinput({
    allowedFileExtensions: ['csv'],
    showPreview: false,
    showUpload: false,
    showCancel: false,
    showRemove: true,
    dropZoneEnabled: false,
    browseClass: 'btn btn-primary',
    removeClass: 'btn btn-default',
    browseIcon: '<i class="fa fa-folder-open"></i> ',
    browseLabel: 'Browse ...',
    removeIcon: '<i class="fa fa-trash"></i> ',
    removeLabel: 'Remove'
  });
});
